<template>
  <div class="search-ads-campaigns-stats-budget-box">
    <div class="row align-middle search-ads-campaigns-stats-budget-box__row">
      <div class="columns">
        {{ $t('ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_‌BUDGET_STATS') }}
      </div>
      <div class="columns shrink">
        <span class="search-ads-campaigns-stats-budget-box__value">
          {{ totalBudgetValue }}
        </span>
        <span>
          {{ $t('RIALS') }}
        </span>
      </div>
    </div>
    <div class="row align-middle search-ads-campaigns-stats-budget-box__row">
      <div class="columns">
        {{ $t('ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_‌DAILY_BUDGET_STATS') }}
      </div>
      <div class="columns shrink">
        <span class="search-ads-campaigns-stats-budget-box__value">
          {{ averageBudgetValue }}
        </span>
        <span>
          {{ $t('RIALS') }}
        </span>
      </div>
    </div>
    <div class="row align-middle search-ads-campaigns-stats-budget-box__row">
      <div class="columns">
        {{ $t('ADVERTISEMENT.CAMPAIGNS.TODAY_SPENT_BUDGET') }}
      </div>
      <div class="columns shrink">
        <span class="search-ads-campaigns-stats-budget-box__value">
          {{ spentBudgetValue }}
        </span>
        <span>
          {{ $t('RIALS') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from '@/utils/number';

export default {
  name: 'SearchAdsCampaignsStatsBudgetBox',
  props: {
    totalBudget: {
      type: Number,
      required: true,
    },
    averageBudget: {
      type: Number,
      required: true,
    },
    spentBudget: {
      type: Number,
      required: true,
    },
  },
  computed: {
    averageBudgetValue() {
      return format(this.averageBudget.toFixed(2));
    },
    totalBudgetValue() {
      return format(this.totalBudget);
    },
    spentBudgetValue() {
      return format(this.spentBudget);
    },
  },
};
</script>

<style lang="scss">
.search-ads-campaigns-stats-budget-box {
  width: 100%;

  background-color: #fff;
  border-radius: $lb-border-radius * 5;
  border: 1px solid $lb-light-gray;

  padding: $global-padding * 2.5 $global-padding * 2;

  &__row:not(:first-child) {
    margin-top: $global-margin;
  }

  &__value {
    font-weight: bold;
    font-size: rem-calc(24px);
  }
}
</style>
